import Head from 'next/head';
import { EarnHero } from './EarnHero';
import { EarnSteps } from './EarnSteps';
import { EarnFAQ } from './EarnFAQ';
import { EarnTopWrapper } from './earn.styles';
import Container from '@components/common/Container';

export default function Earn() {
  return (
    <>
      <Head>
        <title>Earn as LP</title>
        <meta name="description" content="About ArchimedesFi. Our team and values." />
      </Head>
      <section>
        <EarnTopWrapper>
          <Container>
            <EarnHero />
            <EarnSteps />
          </Container>
        </EarnTopWrapper>
        <EarnFAQ />
      </section>
    </>
  );
}
